import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../common/http/fetch-get';
import { getCompatibilityGuideApiConfig } from './config/actions';
export var fetchPopularDevices = function () { return __awaiter(void 0, void 0, void 0, function () {
    var config, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                config = getCompatibilityGuideApiConfig();
                url = config.baseUrl + "/api/thirdparty/popular/" + config.marketLocale;
                return [4 /*yield*/, fetchGet(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
